// extracted by css-extract-rspack-plugin
export default {"pageHeading":"_2546ee8c","pageTitle":"_1a78fc44"};